"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var scrollState = {};
var scrollHandler = function (name) {
    scrollState[name] = window.pageYOffset;
};
exports.default = (function (name) {
    react_1.useEffect(function () {
        window.scrollTo(0, scrollState[name] || 0);
        var eventListener = function () { return scrollHandler(name); };
        document.addEventListener('scroll', eventListener);
        return function () {
            document.removeEventListener('scroll', eventListener);
            window.scrollTo(0, 0);
        };
    }, []);
});
